module.exports = __webpack_public_path__ + "assets/media/graffiti-texture-desktop-2.09b2a2dd.svg";